import React from "react";
import { Link } from "react-router-dom";
import Packages from "./Packages";
import Contact from "./Contact";
import Faq from "./FAQ";
import RulesAndWaiver from "./RulesandWaiver";
import Gallery from "./Gallery";
import Icon from "../components/Icon";
import { venuePhotos } from "../data/venuePhotos";
import { membershipPricing, openPlayPricing, siteInfo } from "../data/siteInfo";
import { formatPackagePrice } from "../data/packages";
import "../css/HomePage.css";

function PlayPrices({ prices }) {
  return (
    <dl className="open-play-prices">
      {prices.map((item) => (
        <div key={item.label}>
          <dt>{item.label}</dt>
          <dd>{formatPackagePrice(item.price)}</dd>
        </div>
      ))}
    </dl>
  );
}

export default function HomePage() {
  const castle = venuePhotos[0];
  return (
    <div className="homepage">
      <section id="home" className="hero-section">
        <div className="site-container hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">
              INDOOR PLAY & BIRTHDAY PARTIES · NORTHRIDGE, CA
            </p>
            <h1>
              Little adventures.
              <br />
              <span>Big memories.</span>
            </h1>
            <p className="hero-description">
              A colorful kingdom for curious kids and the people who love them.
              Come for a play day. Make a birthday magical.
            </p>
            <div className="button-row">
              <Link className="button button-primary" to="/book">
                Book a Party <Icon />
              </Link>
              <Link className="button button-secondary" to="/#open-play">
                Explore Open Play
              </Link>
            </div>
            <Link className="hero-party-link text-link" to="/packagesdetail">
              No service fees. More celebration. <Icon />
            </Link>
            <p className="hero-fee-note">
              10.25% tax applies. Optional add-ons priced separately.
            </p>
          </div>
          <figure className="hero-visual">
            <div className="hero-photo-frame">
              <img
                src={castle.src}
                srcSet={`${castle.small} 480w, ${castle.src} 1280w`}
                sizes="(min-width: 900px) 50vw, 90vw"
                alt={castle.alt}
                width={castle.width}
                height={castle.height}
                fetchpriority="high"
              />
            </div>
            <figcaption className="hero-photo-label">
              <Icon name="sparkle" /> Welcome to their happy place
            </figcaption>
            <span className="hero-sparkle" aria-hidden="true">
              <Icon name="sparkle" />
            </span>
          </figure>
        </div>
        <div className="site-container visit-strip">
          <div>
            <span className="visit-icon">
              <Icon name="sparkle" />
            </span>
            <p>
              <strong>Little ones, big imaginations</strong>
              <span>Indoor play for ages 1–10</span>
            </p>
          </div>
          <div>
            <span className="visit-icon">
              <Icon name="clock" />
            </span>
            <p>
              <strong>Daily · {siteInfo.hours}</strong>
              <span>Call ahead for open play hours</span>
            </p>
          </div>
          <a
            href={siteInfo.directions}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="visit-icon">
              <Icon name="pin" />
            </span>
            <p>
              <strong>Find us in Northridge</strong>
              <span>
                19444 Business Center Dr <Icon name="external" />
              </span>
            </p>
          </a>
        </div>
      </section>
      <section id="open-play" className="open-play-section section-space">
        <div className="site-container">
          <div className="section-heading">
            <p className="eyebrow">EVERYDAY MAGIC</p>
            <h2>A play day, their way.</h2>
            <p>
              Climb, explore, and let their imagination lead. Choose a
              three-hour visit or keep the adventures coming with a membership.
            </p>
          </div>
          <div className="open-play-grid">
            <div className="open-play-guide">
              <span className="round-icon">
                <Icon name="clock" />
              </span>
              <h3>Plan a little adventure.</h3>
              <p>
                <strong>
                  Monday–Sunday
                  <br />
                  {siteInfo.hours}
                </strong>
              </p>
              <p>
                Open play is available when the space is free from private
                events. Walk-ins are welcome; call before visiting to check
                hours.
              </p>
              <p>
                Two adults per family are included. Children must stay with a
                parent or guardian. Bring grip socks for kids and socks for
                adults.
              </p>
              <a className="text-link" href={siteInfo.phoneHref}>
                Call {siteInfo.phone} <Icon name="phone" />
              </a>
            </div>
            <article className="play-price-card">
              <p className="eyebrow">DROP IN & PLAY</p>
              <h3>Daily pass</h3>
              <p className="price-card-subtitle">
                Three hours of happy exploring
              </p>
              <PlayPrices prices={openPlayPricing} />
              <p className="form-help">
                Per visit · Two adults per family included
              </p>
              <a className="button button-teal" href={siteInfo.phoneHref}>
                Check open play hours <Icon name="phone" />
              </a>
            </article>
            <article className="play-price-card membership-card">
              <p className="eyebrow">MORE DAYS, MORE PLAY</p>
              <h3>Monthly membership</h3>
              <p className="price-card-subtitle">
                10 sessions · Three hours per visit
              </p>
              <PlayPrices prices={membershipPricing} />
              <p className="form-help">
                Visits available when the space is free from events.
              </p>
              <a
                className="text-link"
                href={`mailto:${siteInfo.email}?subject=Open%20play%20membership`}
              >
                Ask about membership <Icon />
              </a>
            </article>
          </div>
        </div>
      </section>
      <section id="packages" className="party-section section-space">
        <div className="site-container">
          <Packages />
        </div>
      </section>
      <section id="gallery" className="gallery-section section-space">
        <div className="site-container">
          <Gallery />
        </div>
      </section>
      <section id="rules-waiver" className="before-visit-section section-space">
        <div className="site-container">
          <RulesAndWaiver />
        </div>
      </section>
      <section id="waiver" className="faq-section section-space">
        <div className="site-container">
          <Faq />
        </div>
      </section>
      <section id="contact" className="contact-section section-space">
        <div className="site-container">
          <Contact />
        </div>
      </section>
    </div>
  );
}
